import {Component} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SessionService} from '../../services/session.service';
import {UserHal} from '../../models/HAL/user-hal.model';
import {Session} from '../../models/session.model';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';

@Component({
  selector: 'app-initialization',
  imports: [],
  template: ''
})
export class InitializationComponent {
  constructor(
    activatedRoute: ActivatedRoute,
    router: Router,
    sessionService: SessionService,
    loadingSpinnerService: LoadingSpinnerService
  ) {
    loadingSpinnerService.show();
    const userHal: UserHal = new UserHal(activatedRoute.snapshot.data['user']);
    let session: Session = {
      user: userHal,
      ongoingLogin: false
    }
    sessionService.setSession(session);
    router.navigate([userHal._links.getLink('teams')!.getRoute()]).then();
  }
}
